export enum RoutesEnum {
    Forms = '/form',
    WebRequestForm = '/web-request-form',
    ConsultDocumentPage = '/consult-data-form',
    ClientConsultGR = '/clients-consult-gr',
    ClientConsulMultiProducts = "/clients-consult-multiproducts"
}